import React from 'react';
import { useAtomValue } from 'jotai';
import { useViewport } from '../../hooks/useViewport';
import { useSelectedCategory, useMsId } from '../../store/appStore';
import { OneColumnLayout, TwoColumnLayout } from '../../components/layouts';
import { MobileTemplateSelection } from './MobileTemplateSelection/MobileTemplateSelection';
import { TemplateSideContent } from './TemplateSelection/TemplateSideContent';
import { TemplateSelection } from './TemplateSelection/TemplateSelection';
import { LoadingGridWrapper } from '../../components/ProductLoadingGrid/LoadingGridWrapper';
import { useSpec } from '../../hooks/useSpec';
import { SelectThemeFirst } from '../../experiments';
import { isProductsLoadingCompleteAtom } from './atoms';

export function TemplateSelectionWrapper() {
  const { isMobile } = useViewport();
  const msId = useMsId();
  const selectedCategory = useSelectedCategory();
  const isProductsLoadingComplete = useAtomValue(isProductsLoadingCompleteAtom);
  const shouldSelectThemeFirst = useSpec(SelectThemeFirst);

  const shouldShowLoadingGrid = shouldSelectThemeFirst ? false : !msId || !isProductsLoadingComplete;

  if (!selectedCategory) {
    return null;
  }

  if (shouldShowLoadingGrid) {
    return <LoadingGridWrapper category={selectedCategory} />;
  }

  if (isMobile) {
    return <OneColumnLayout content={<MobileTemplateSelection />} />;
  }

  return (
    <TwoColumnLayout
      mainContent={<TemplateSelection />}
      sideContent={<TemplateSideContent />}
      mainContentSpan={6}
      sideCellStyle={{ maxWidth: '520px' }}
    />
  );
}
